import React, { useEffect } from 'react'
import './App.css'
import AuthProvider from './providers/AuthProvider.js'
import MsalProvider from './providers/MsalProvider.js'
import { Routes } from './routes/Routes'
import GlobalStyling from './GlobalStyling.js'
import { config } from './config'
import pirTerminology from './util/pirTerminology'
import useAxiosInterceptors from './dataClient/hooks/useAxiosInterceptors'

function AxiosInterceptorSetup({ children }) {
  useAxiosInterceptors()
  return children
}

function App(props) {
  useEffect(() => {
    if (config.foi.active && config.pir.active) {
      document.title = 'VivaCitadel'
    } else if (config.foi.active) {
      document.title = 'Freedom of Information Request'
    } else if (config.pir.active) {
      document.title = pirTerminology.getRequestName()
    } else {
      document.title = 'VivaCitadel'
    }
  }, [])

  return (
    <>
      <GlobalStyling />
      <MsalProvider>
        <AuthProvider>
          <AxiosInterceptorSetup>
            <Routes {...props} />
          </AxiosInterceptorSetup>
        </AuthProvider>
      </MsalProvider>
    </>
  )
}

export default App
